module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/sharepromotionalcode/email/email-list/email-list.component.css
// module id = ./src/app/sharedcomponents/sharepromotionalcode/email/email-list/email-list.component.css
// module chunks = main